import util from '@utils/util';
export default {
  name: 'filterBar',
  props: {
    title: String,
    filters: Object,
    defaultSelected: String
  },
  data: function data() {
    return {
      selected: ''
    };
  },
  components: {},
  computed: {},
  methods: {
    updateSelected: function updateSelected() {
      // eslint-disable-next-line no-nested-ternary
      this.selected = this.defaultSelected ? this.defaultSelected : this.filters ? Object.keys(this.filters)[0] : '';
    },
    itemClickHandler: function itemClickHandler(key, filter) {
      util.KEWLSensorTrack({
        lmweb_clickText: '探索页分类',
        lmweb_tabName: filter
      });
      this.selected = key;
    }
  },
  watch: {
    filters: function filters() {
      this.updateSelected();
    },
    selected: function selected(val) {
      this.$emit('select', val);
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  created: function created() {
    this.updateSelected();
  },
  destroyed: function destroyed() {}
};